
import {postSignInAuth} from "../api/lixil-api";

// export const SET_APP_JWT_TOKEN = "SET_APP_JWT_TOKEN";
//
// export const setAppJwtToken = (jwtToken) => ({
//   type: SET_APP_JWT_TOKEN,
//   payload: {jwtToken}
// });

export const setLixilAuthorizationToken = () => {
  return async (dispatch, getState) => {

    const {useLixilCalendar} = getState().fabricatorState;
    if (!useLixilCalendar) {
      return
    }
    const postAuthResponse = await postSignInAuth();
    console.log("postAuthResponse", postAuthResponse);
    // if (postAuthResponse && postAuthResponse.data && postAuthResponse.data.data && postAuthResponse.data.data.jwtToken) {
      // dispatch(setAppJwtToken(postAuthResponse.data.data.jwtToken)); // just in case, we don't need it anymore
    // }
    return false
  }
}

export const LIXIL_PRODUCT_TYPES = {
  srBathing: "SR BATHING",
  bathRemodel: "Bath Remodel",
}

const lixilTermsText = "By clicking “Let's Review” above, I consent to receive from American Standard and any party on its behalf at any time emails, telemarketing calls using an autodialer, artificial voices or pre-recordings and SMS text messages, which could result in wireless charges, at the number provided above. I understand that consent is not a condition of purchase. I also agree to the Terms of Use and Privacy policy, which are also linked at the bottom of this page.";

export const getLixilCampaignInfo = (store) => {

  const {wizardState, appointmentState, globalState} = store;

  // const isShowerRemodel = wizardState.wizardSelectedValues
  // && wizardState.wizardSelectedValues[1]
  // && wizardState.wizardSelectedValues[1].selectedFeature && (
  //     (wizardState.wizardSelectedValues[1].selectedFeature.customDisplayName === "Replace Shower")
  //     || (wizardState.wizardSelectedValues[1].selectedFeature.sharedFeatureName === "Replace Shower")
  //     || (
  //       (wizardState.wizardActiveItem && (wizardState.wizardActiveItem.id === 2)) && (
  //         (wizardState.wizardSelectedValues[1].selectedFeature.customDisplayName === "Convert Tub to A Shower")
  //         || (wizardState.wizardSelectedValues[1].selectedFeature.sharedFeatureName === "Convert Tub to A Shower")
  //       )
  //     )
  //   );

  const textWithUpdatedButton = globalState.footerInfoButtonText
    ? lixilTermsText.replace("Let's Review", globalState.footerInfoButtonText)
    : lixilTermsText;

  const isSrBathing = wizardState.wizardActiveItem && (wizardState.wizardActiveItem.id === 2);

  const addressIsNotSupported = appointmentState && appointmentState.appointmentsNotAvailable;

  if (isSrBathing) {
    return {
      "Campaign": "SOCIAL",
      "SubID": addressIsNotSupported ? "8087" : "8077",
      "PubID": addressIsNotSupported ? "SB-Social-OnlineForm-NoAppt" : "Social-SB-OnlineApptForm",
      "DNIS": "855-254-7620",
      "Product": LIXIL_PRODUCT_TYPES.srBathing,
      "terms_stc": textWithUpdatedButton,
      "promoter_id_stc": addressIsNotSupported ? "" : "3846",
    }
  }
  return {
    "Campaign": "SOCIAL",
    "SubID": addressIsNotSupported ? "8088" : "8079",
    "PubID": addressIsNotSupported ? "BR-Social-OnlineForm-NoAppt" : "BR-Social-OnlineApptForm",
    "DNIS": "855-254-7623",
    "Product": LIXIL_PRODUCT_TYPES.bathRemodel,
    "terms_stc": textWithUpdatedButton,
    "promoter_id_stc": addressIsNotSupported ? "" : "3846",
  }
}
